export enum FilterType {
  Mention = 'mention',
  Publication = 'publication',
  Routing = 'routing',
}
